'use client';

import { handleClickAttributionClick } from '../core';
import { useUtag } from '../hooks';

import type { FC } from 'react';

export const TrackClickAttribution: FC = () => {
  useUtag(() => {
    document.addEventListener('click', handleClickAttributionClick);

    return () => {
      document.removeEventListener('click', handleClickAttributionClick);
    };
  }, []);

  return null;
};
